<script>
import Information from './Information.svelte';
export let date;
</script>


<div class="formContainer">
  <div class="formContainer__left">
    <slot/>
  </div>
  <div class="formContainer__right">
    <Information date={date} />
  </div>
</div>


<style>
.formContainer {
  background-color: #ffffff;
  display: flex;
  max-width: 1000px;
  margin: 6rem auto 0;
  animation: animForm 0.8s cubic-bezier(.36,.62,.53,1.13) forwards;
}

@keyframes animForm {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}


.formContainer .formContainer__left {
  background-color: #ffffff;
  padding: 5rem;
  max-width: 60%;
  flex: 0 0 60%;
}

.formContainer .formContainer__right {
  background-color: #f4f6f8;
  padding: 5rem;
  max-width: 40%;
  flex: 0 0 40%;
}

@media(max-width: 1023px) {
  .formContainer {
    display: block;
    margin: 5rem -2rem 0;
  }

  .formContainer .formContainer__left {
    background-color: #ffffff;
    padding: 5rem;
    max-width: 100%;
    flex: 0 0 100%;
  }
  
  .formContainer .formContainer__right {
    background-color: #f4f6f8;
    padding: 5rem;
    max-width: 100%;
    flex: 0 0 100%;
  }
}

@media(max-width: 767px) {
  .formContainer .formContainer__left {
    padding: 5rem 3rem;
  }

  .formContainer .formContainer__right {
    padding: 3rem;
  }
}
</style>